import { Injectable, computed, signal } from '@angular/core';

export type NavDensity = 'expanded' | 'compact';
export type NavMode = 'docked' | 'overlay';

export interface NavPrefs {
  density: NavDensity;
  mode: NavMode;
  opened: boolean;
}

const KEY = 'cografa:nav';
const DEFAULTS: NavPrefs = { density: 'expanded', mode: 'docked', opened: true };

@Injectable({ providedIn: 'root' })
export class SidenavPrefsService {
  readonly prefs = signal<NavPrefs>(read());
  readonly density = computed(() => this.prefs().density);
  readonly mode = computed(() => this.prefs().mode);
  readonly opened = computed(() => this.prefs().opened);

  patch(partial: Partial<NavPrefs>): void {
    const next = { ...this.prefs(), ...partial };
    this.prefs.set(next);
    localStorage.setItem(KEY, JSON.stringify(next));
  }
}

function read(): NavPrefs {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw) as Partial<NavPrefs>;
    return {
      density: parsed.density === 'compact' ? 'compact' : 'expanded',
      mode: parsed.mode === 'overlay' ? 'overlay' : 'docked',
      opened: parsed.opened !== false,
    };
  } catch {
    return { ...DEFAULTS };
  }
}
